import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { MuiThemeProvider } from 'material-ui/styles';
import Zoom from 'react-reveal/Zoom';
import { required, maxLength190 } from '../../validation/FormValidation';
import {
  TextArea,
  AutoCompleteForm,
  DropZoneImageCover
} from '../../utils_form/FormComponents';
import ButtonDefault, { ButtonDisable } from '../../utils/FormsComponents';
import TagApi from '../../../Logicas/TagApi';
import TrailsApi from '../../../Logicas/TrailsApi';

require('./trailinitial.css');

class TrailCreateInitial extends Component {
  saveTrail = (values) => {
    const { currentTrail } = this.props;

    if (!values.image && !(currentTrail && currentTrail.id)) {
      this.props.showError();
      return;
    }

    if (currentTrail && currentTrail.id) {
      this.props.updateTrail(currentTrail.id, values);
    } else {
      this.props.createTrail(values);
    }
  };

  render() {
    const {
      handleSubmit,
      valid,
      title,
      description,
      showModal,
      currentTrail,
      currentTrailCourses,
      hasTrail
    } = this.props;

    const isEdit = hasTrail;

    return (
      <div className="container">
        <MuiThemeProvider>
          <Zoom>
            <form onSubmit={handleSubmit(this.saveTrail)}>
              <div className="body-form-initialo-course">
                <p className="title-name-course">
                  {title || 'Título da Trilha'}
                </p>

                <div>
                  <Field
                    name="image"
                    component={(e) =>
                      DropZoneImageCover({
                        ...e,
                        dispatchImageError: this.props.dispatchImageError
                      })
                    }
                    validations={[required]}
                  />
                </div>

                <div className="display-form">
                  <div className="form-input-body">
                    <div className="form-group-input">
                      <TextArea
                        rows={1}
                        rowsMax={1}
                        name="title"
                        label="NOME DA TRILHA"
                        validations={[required, maxLength190]}
                        labelsecondari="Escreva o nome da trilha"
                      />
                      <p className="view-characters-description">
                        {title &&
                          title.length <= 190 &&
                          `${190 - title.length} caracteres restantes.`}
                      </p>
                    </div>

                    <div className="form-group-input">
                      <TextArea
                        rows={1}
                        rowsMax={1}
                        label="DESCRIÇÃO"
                        name="description"
                        validations={[required, maxLength190]}
                        labelsecondari="Escreva uma breve descrição"
                      />
                      <p className="view-characters-description">
                        {description &&
                          description.length <= 190 &&
                          `${190 - description.length} caracteres restantes.`}
                      </p>
                    </div>

                    <div className="form-group-input">
                      <AutoCompleteForm
                        selectInputWidth="100%"
                        label="Tags"
                        tags={this.props.tagsWithIds}
                        name="tags"
                        validations={[required]}
                        isLoading={this.props.isLoadingTags}
                        getTagAutoComplete={() => {}}
                        infiniteScroll={{
                          searchByRequest: true,
                          loadMore: (page, search) => {
                            return this.props.getTags(
                              page,
                              search,
                              false,
                              true
                            );
                          }
                        }}
                      />
                    </div>

                    <div className="form-group-input-row">
                      {valid ? (
                        <ButtonDefault
                          label={isEdit ? 'Atualizar trilha' : 'Criar trilha'}
                        />
                      ) : (
                        <ButtonDisable
                          label={isEdit ? 'Atualizar trilha' : 'Criar trilha'}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Zoom>
        </MuiThemeProvider>
      </div>
    );
  }
}

let InitializeFromStateForm = reduxForm({
  form: 'create_trail_form',
  enableReinitialize: true,
  destroyOnUnmount: true
})(TrailCreateInitial);

const mapDispatchToProps = (dispatch) => ({
  getTags: async (page, search, _, withCount) => {
    const res = await dispatch(
      TagApi.getTagsUserV2(page, search, _, withCount)
    );
    return res;
  },
  createTrail: (values) => {
    dispatch(TrailsApi.createTrail(values));
  },
  updateTrail: (id, values) => {
    dispatch(TrailsApi.updateTrail(id, values));
  },
  showError: () =>
    dispatch({
      type: 'OPEN_ERROR',
      alert: { visible: true, message: 'É obrigatório adicionar uma imagem' }
    }),
  dispatchImageError: () => {
    dispatch({
      type: 'OPEN_ERROR',
      alert: {
        visible: true,
        message: 'Não foi possível carregar a imagem'
      }
    });
  }
});

const selector = formValueSelector('create_trail_form');

InitializeFromStateForm = connect(
  (state) => ({
    listTagName: state.tagsWithPagination.tags,
    isLoadingTags: state.tagsWithPagination.isLoading,
    title: selector(state, 'title'),
    description: selector(state, 'description'),
    currentTrail: state.trails.currentTrail,
    tagsWithIds: state.tagsWithIds.tags,
    currentTrailCourses: state.trails.currentTrailCourses,
    initialValues:
      state.trails && state.trails.currentTrail && state.trails.currentTrail.id
        ? {
            title: state.trails.currentTrail.title,
            description: state.trails.currentTrail.description,
            tags: state.trails.currentTrail.tags.map((tag) => ({
              value: tag.id,
              label: tag.name
            })),
            image:
              (state.trails &&
                state.trails.currentTrail &&
                state.trails.currentTrail.image &&
                state.trails.currentTrail.image.url) ||
              null
          }
        : undefined
  }),
  mapDispatchToProps
)(InitializeFromStateForm);

export default InitializeFromStateForm;
